/* import __COLOCATED_TEMPLATE__ from './reviewable-field-editor.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
